// Dropdowns
const accordionTriggers = document.querySelectorAll('.collapse-trigger');

// Show dropdown
var collapseShow = function (elem) {

	// Get the natural height of the element
	var getHeight = function () {
		elem.style.display = 'block'; // Make it visible
		var height = elem.scrollHeight + 'px'; // Get it's height
		elem.style.display = ''; //  Hide it again
		return height;
	};

	var height = getHeight(); // Get the natural height

	elem.classList.add('is-visible'); // Make the element visible
	elem.style.height = height; // Update the max-height
  elem.previousElementSibling.classList.add('open');
  elem.previousElementSibling.setAttribute("aria-expanded", "true");

	// Once the transition is complete, remove the inline max-height so the content can scale responsively
	window.setTimeout(function () {
		elem.style.height = '';
	}, 350);

};

// Hide dropdown
var collapseHide = function (elem) {

	// Give the element a height to change from
	elem.style.height = elem.scrollHeight + 'px';

	// Set the height back to 0
	window.setTimeout(function () {
		elem.style.height = '0';
	}, 1);

  elem.previousElementSibling.classList.remove('open');
  elem.previousElementSibling.setAttribute("aria-expanded", "false");

	// When the transition is complete, hide it
	window.setTimeout(function () {
		elem.classList.remove('is-visible');
	}, 350);

};

// Toggle dropdown
var collapseToggle = function (elem, timing) {

	// If the element is visible, hide it
	if (elem.classList.contains('is-visible')) {
		collapseHide(elem);
		return;
	}

	// Otherwise, show it
	collapseShow(elem);

};

// Listen for dropown clicks
if(accordionTriggers) {
  accordionTriggers.forEach((trigger, index) => {
    trigger.addEventListener('click', (e) => {
      const content = e.currentTarget.nextElementSibling;

      // Change image if trigger-image class is present
      const toggleImage = trigger.classList.contains('trigger-image');

      if(toggleImage) {
        const index = trigger.dataset.index;
        const images = trigger.closest('.features-7').querySelectorAll('.image');
        
        images.forEach((image) => {
          image.classList.remove('active');
        });

        images[index].classList.add('active');
      }

      content.classList.contains('is-visible');

      collapseToggle(content);

      accordionTriggers.forEach((trigger, index) => {
        if(e.currentTarget != trigger) {
          const content = trigger.nextElementSibling;
          collapseHide(content);
        }
      });
    });
  });
}